import { geo } from './../helpers/google';
import { googleMapStyles } from './../helpers/googleMapStyle';

class Clinic {
    constructor() {
        this.googleApi = null;
        this.currentLocation = null;
    }

    init(googleApi, resources) {
        const self = this;

        self.googleApi = googleApi;

        geo.init(googleApi, resources);

        let pos = self.currentLocation ? Promise.resolve(self.currentLocation) : geo.location.getCurrent();
        const elem = $('#hd-directions');

        pos.then(
            loc => {
                elem.attr('href', `${elem.attr('href')}&origin=${loc.lat()},${loc.lng()}`);

                self.newMap(`${elem.attr('href')}&origin=${loc.lat()},${loc.lng()}`);
            },
            () => {
                self.newMap(`${elem.attr('href')}`);
            }
        );
    }

    newMap(url) {
        const self = this;
        const elem = $('.clinic-map');
        const marker = $('.marker');

        const latlng = new self.googleApi.maps.LatLng(marker.attr('data-lat'), marker.attr('data-lng'));

        var args = {
            zoom: 14,
            center: latlng,
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: googleMapStyles.blackAndWhite,
        };

        // create map
        const map = new self.googleApi.maps.Map(elem[0], args);

        // add marker
        self.addMarker(latlng, map, url);
    }

    addMarker(latlng, map, url) {
        const self = this;

        const marker = new self.googleApi.maps.Marker({
            position: latlng,
            map: map,
            icon: geo.resources.icons.markerDefault,
        });

        marker.addListener('click', () => {
            window.open(url, '_blank');
        });
    }
}

(function(hd) {
    hd.views = hd.views || {};
    hd.views.clinic = new Clinic();
})((window.hd = window.hd || {}));



// WEBPACK FOOTER //
// ./scripts/booking/views/clinic.js